import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.css']
})
export class ProductsComponent implements OnInit {
  filteredMembers= [
    {
      "SNo": 1,
      "LeadID": "IL-00001",
      "Category": "Decors",
      "LeadType": "Online",
      "CreatedDate": "23.05.2025",
      "CustomerName": "Akhila",
      "MobileNumber": "8954565758",
      "EmailId": "akhila.nemali@gmail.com",
      "Product": "Miniature - 3D",
      "ProductValue": "₹ 65000",
      "Remarks": "Enquiry"
    },
    {
      "SNo": 2,
      "LeadID": "IL-00002",
      "Category": "Decors",
      "LeadType": "Walk - In",
      "CreatedDate": "22.05.2025",
      "CustomerName": "Niranjan Yadav",
      "MobileNumber": "7658798734",
      "EmailId": "niranjan.yadav@gmail.com",
      "Product": "Creative Art",
      "ProductValue": "₹135000",
      "Remarks": "Purchased"
    },
    {
      "SNo": 3,
      "LeadID": "IL-00003",
      "Category": "Decors",
      "LeadType": "Referal",
      "CreatedDate": "22.05.2025",
      "CustomerName": "Prakash Rao",
      "MobileNumber": "6743341277",
      "EmailId": "prakash.rao@gmail.com",
      "Product": "Wooden Craft",
      "ProductValue": "₹ 15000",
      "Remarks": "Shipped"
    },
    {
      "SNo": 4,
      "LeadID": "IL-00004",
      "Category": "Decors",
      "LeadType": "Online",
      "CreatedDate": "22.05.2025",
      "CustomerName": "Raj Kumar",
      "MobileNumber": "9943453452",
      "EmailId": "raj.kumar@gmail.com",
      "Product": "Floral Clock",
      "ProductValue": "₹ 15499",
      "Remarks": "Order Placed"
    },
    {
      "SNo": 5,
      "LeadID": "IL-00005",
      "Category": "Decors",
      "LeadType": "Online",
      "CreatedDate": "21.05.2025",
      "CustomerName": "Nethra",
      "MobileNumber": "8431271662",
      "EmailId": "Netha.anumula@gmail.com",
      "Product": "Antique Face",
      "ProductValue": "₹ 25000",
      "Remarks": "Bulk Order"
    }
  ]
  
  constructor() { }

  ngOnInit(): void {
  }

}
